<template>
  <div class="content"  v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div required">公司名称</div>
          <el-select v-model="search.tenantGuid" placeholder="请选择" filterable clearable class="ipt-sty">
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div required">客户类型</div>
          <el-select @change="dataTypeChange" v-model="page.dataType" placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in dataTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" v-show="page.dataType === '1' || page.dataType === ''">
          <div class="search-area-div">客户名称</div>
          <el-input v-model="search.customerName" class="ipt-sty" clearable placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6" v-show="page.dataType === '2'">
          <div class="search-area-div">医院名称</div>
          <el-input v-model="search.medNameKeyword" class="ipt-sty" clearable placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6" v-show="page.dataType === '3'">
          <div class="search-area-div">商业公司名称</div>
          <el-input v-model="search.franchiseeName" class="ipt-sty" clearable placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">所属省份</div>
          <el-select v-model="search.province" placeholder="请选择" class="ipt-sty" clearable filterable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">更新时间</div>
          <el-date-picker
            v-model="updateTimeRange"
            size="mini"
            class="ipt-sty"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            clearable
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">人员信息</div>
          <el-input
            size="mini"
            v-model="search.belongStaffName"
            class="ipt-sty"
            placeholder="请输入姓名/手机号"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否底库建档</div>
          <el-select v-model="search.srcEsDb" clearable placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in dataSourceOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
       
      </el-row>
      <el-row :gutter="24" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">更新人</div>
          <el-input
            size="mini"
            v-model="search.submitStaffName"
            class="ipt-sty"
            placeholder="请输入数据更新人姓名"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">建档时间</div>
          <el-date-picker
            size="mini"
            v-model="createTimeRange"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col> 
        <el-col :span="6">
          <div class="search-area-div">审核时间</div>
          <el-date-picker
            size="mini"
            v-model="approveTimeRange"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col> 
      </el-row>
    </div>
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="searchHead">
        <div class="searchHead-left">
          <div
            v-for="(item, index) in tabText"
            :key="index"
            :class="activeTab == index ? 'tab active' : 'tab'"
            @click="changeTab(index, item)"
          >
            <div>{{ item.name }}</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="button-area p10">
          <el-button size="mini" type="info" @click="batchAudit()">批量审核</el-button>
        </div>
      </div>
      <!-- 药店 -->
      <CustomerTable  
        ref="table"
        v-if="page.dataType === '1'||page.dataType === ''" 
        :height="tableHeight" 
        :data="tableData" 
        :page="page" 
        :loading="tableLoading"
        @handleSelectionChange="handleSelectionChange"
        @toDetail="toDetail"
        @toAudit="toAudit"
        @historyReviewRecords="historyReviewRecords"
       
      ></CustomerTable>
      <!-- 医院 -->
      <MedTable  
        ref="table"
        v-if="page.dataType === '2'" 
        :height="tableHeight" 
        :data="tableData" 
        :page="page" 
        :loading="tableLoading"
        @handleSelectionChange="handleSelectionChange"
        @toDetail="toDetail"
        @toAudit="toAudit"
        @historyReviewRecords="historyReviewRecords"
       
      ></MedTable>
      <!-- 商业公司 -->
      <CommercialCompanyTable  
        ref="table"
        v-if="page.dataType === '3'" 
        :height="tableHeight" 
        :data="tableData" 
        :page="page" 
        :loading="tableLoading"
        @handleSelectionChange="handleSelectionChange"
        @toDetail="toDetail"
        @toAudit="toAudit"
        @historyReviewRecords="historyReviewRecords"
       
      ></CommercialCompanyTable>
     
      <Pagination :page="page" :data="tableData" @getData="getData"></Pagination>
    </div>
    <!-- 勾选原因弹框 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="900px">
      <div slot="title" class="dialog-title">
        {{ isBatch?'批量审核':'审核' }}
      </div>
      <div class="dialogCon">
        <div class="cols" style="display:flex">
          <div>
            <span class="audit-title">审核结果：</span>
            <el-radio v-model="approvalState" label="Y">合格</el-radio>
            <el-radio v-model="approvalState" label="N">不合格</el-radio>
          </div>
        </div>
        <!-- <div class="cols">
          <el-input v-model="revokeCause" placeholder="请填写撤回的原因"></el-input>
        </div> -->
        <div v-if="approvalState==='N'">
          <span class="audit-title">审核原因：</span>
        <div class="dialogCon-checkbox">
          <el-checkbox-group v-model="checkedIssues">
            <!-- <el-checkbox v-for="(item, index) in reasonList" :key="index" :label="item" class="checkbox-hover">{{
              item.evaluationRuleDesc
            }}</el-checkbox> -->
            <el-form>
              <el-form-item>
                <div  class="dialogCon-checkbox-type">
                  <!-- <div style="height: 20px">{{ item.text }}</div> -->
                  <div class="type-check-list">
                    <div class="type-check-item" v-for="(item, idx) in getCodeListByKey('客户建档审核不合格原因')" >
                      <el-checkbox :label="item.text">{{ item.text }}</el-checkbox>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </el-checkbox-group>
        </div>
        </div>
        
        <!-- 原因说明 -->
        <div class="dialogCon-describe">
          <p>
            <span slot="label" style="color: red" v-if="approvalState==='N'">*</span>
            <span>原因说明</span>
          </p>
          <!-- :disabled="disabledInput" -->
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="issuesDesc"
            @input="checkedIssuesTextEvent"
            maxlength="200"
            show-word-limit
            placeholder="请输入内容"
            clearable
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="info" @click="toAuditSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <ReviewRecords></ReviewRecords>
  </div>
</template>

<script>
import btnPermisson from '../mixins/btnPermisson.js';
import areaJson from '../../assets/js/china_address_v4.js';
import dialogMap from '../../components/dialogMap';
import ReviewRecords from '../taskAudit/components/reviewRecords';
import CustomerTable from './components/CustomerTable';
import MedTable from './components/MedTable';
import CommercialCompanyTable from './components/CommercialCompanyTable';
import Pagination from './components/pagination.vue';
export default {
  components: {
    dialogMap,
    ReviewRecords,
    CustomerTable,
    MedTable,
    CommercialCompanyTable,
    Pagination,
  },
  mixins: [btnPermisson],
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 264,
      contentMainHeight: window.innerHeight - 200,
      dialogVisible: false,//批量审核的弹窗
      approvalState:'',//审核结果
      tabText: [
        { name: '全部', value: '' },
        { name: '待审批', value: 'A' },
        { name: '合格', value: 'Y' },
        { name: '不合格', value: 'N' },
      ],
      checkedIssues: [], //选中的原因
      issuesDesc: '', //原因说明
      disabledInput: false, // 禁止输入
      createTimeRange:'',
      updateTimeRange:'',
      approveTimeRange:'',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        dataType:'1',//资料类型
        loadApproveState:'Y',
      },
      search: {
        tenantGuid: '',//公司名称
        customerName:'',//客户名称
        medNameKeyword: '',//医院
        franchiseeName: '',//商业公司
        province:'',//所属省
        belongStaffName: '',//人员信息
        submitStaffName: '',//更新人
        bizStateList:['Y'],//启用状态'Y','S'
        plfApproveState:'A',//审核状态
        srcEsDb:'',//是否底库建档
      },
      // 客户类型选项
      dataTypeOptions: [
        {
          value: '1',
          label: '药店'
        },
        {
          value: '2',
          label: '医院'
        },
        {
          value: '3',
          label: '商业公司'
        }
      ],
      //是否底库建档
      dataSourceOptions: [
        {
          value: 'N',
          label: '否'
        },
        {
          value: 'Y',
          label: '是'
        }
      ],
      //审批状态
      approveStateObj: {
        A: '待审批',
        Y: '合格',
        N: '不合格',
      },
      options: areaJson,//省份
      fullscreenLoading:false,
      tableLoading: false,
      tableData: [],
      tenantList: [],//公司列表
      isBatch:false,//是否批量审核
      multipleSelection: [],
      type: {
        A: 'warning',
        Y: 'success',
        N: 'danger',
      },
      activeTab: 1,

    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 344;
        this.contentMainHeight = window.innerHeight - 284;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 264;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
    // 监听原因说明弹框
    dialogVisible(val) {
      if (val) {
        this.issuesDesc = '';
      }
    },
    // 监听审核状态
    approvalState(val) {
      this.disabledInput = false;
      this.issuesDesc = '';
      this.checkedIssues = [];
      if (val=='N') {
        this.disabledInput = true;
      }
    },
    //审核原因
    checkedIssues: {
      handler(newVal, oldVal) {
        console.log('kk',newVal, oldVal);
        
        if (newVal && newVal.length) {
          this.disabledInput = false;
        } else if(this.approvalState!='Y'){
          this.disabledInput = true;
        }
        this.checkedIssuesChange(newVal, oldVal);
        if (this.approvalState === 'Y' && newVal.length === 0) {
          this.issuesDesc = '';
        }
      },
    },
  },
  computed: {
    messageErrorTip() {
      return this.approvalState === 'R' ? '撤销失败' : '审核失败';
    },
    postUrl() {
      let lookup={
        '1':`/${serverConfig.msCustomerService}/customer/data/get`,
        '2':`/${serverConfig.msCustomerService}/med/data/get`,
        '3':`/${serverConfig.msCustomerService}/franchisee/data/plf-approve-page-list`,
      }

      return lookup[this.page.dataType];
    }, 
  },
  activated() {
    if (this.search.tenantGuid ){
      this.getData();
    }
  },
  async created() {
    // await this.getFormMedConfig()
    this.getTenantOperationRelList(true);
    // this.getLevelList(2)
    this.getFormConfig()//只有药店建档需要走配置
    // this.$refs.multipleTable.doLayout()
  },
  methods: {
    // 初始化获取数据区域---start----------
    // 获取公司列表
    getTenantOperationRelList(flg) {
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` + '&tenantGuid=' + localStorage.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取配置
    getFormConfig() {
      this.api
        .get(
          `/${serverConfig.msConfigureService}/function/func/get-by-code?functionCode=TZYDJD`
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            if (data && data.fieldList) {
              data.fieldList.filter((i) => {
                return (
                  (i.appSideType == "0" || i.appSideType == "1") &&
                  i.showPosition.indexOf("1") > -1
                );
              });
              localStorage.setItem("TZYDJD_CONFIG", JSON.stringify(data));
            }
            if (!resp.data.data) {
              localStorage.removeItem("TZYDJD_CONFIG");
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 初始化获取数据区域---end----------


    // 搜索列表区域---start----------
    //客户类型改变
    dataTypeChange(){
      this.search.customerName=''
      this.search.medNameKeyword=''
      this.search.franchiseeName=''
      this.tableData=[]
      this.$refs.multipleSelection?.clearSelection()
      this.getData(true)
    },
    //获取列表数据
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if (!this.search.tenantGuid ){
        this.$message.error("请选择所属公司")
        return
      }
      if (!this.page.dataType ){
        this.$message.error("请选择客户类型")
        return
      }
      // if (!self.timeRange) {
      //   self.search.startTime = ""
      //   self.search.endTime = ""
      // } else if (self.timeRange && self.timeRange.length != 0) {
      //   self.search.startTime = self.timeRange[0] + ' ' + '00:00:00';
      //   self.search.endTime = self.timeRange[1] + ' ' + '23:59:59';
      // }
      if (!self.updateTimeRange) {
        self.search.submitStartTime = ""
        self.search.submitEndTime = ""
      } else if (self.updateTimeRange && self.updateTimeRange.length != 0) {
        self.search.submitStartTime = self.updateTimeRange[0] + ' ' + '00:00:00';
        self.search.submitEndTime = self.updateTimeRange[1] + ' ' + '23:59:59';
      }
      if (!self.createTimeRange) {
        self.search.startTime = ""
        self.search.endTime = ""
      } else if (self.createTimeRange && self.createTimeRange.length != 0) {
        self.search.startTime = self.createTimeRange[0] + ' ' + '00:00:00';
        self.search.endTime = self.createTimeRange[1] + ' ' + '23:59:59';
      }
      if (!self.approveTimeRange) {
        self.search.approveStartTime = ""
        self.search.approveEndTime = ""
      } else if (self.approveTimeRange && self.approveTimeRange.length != 0) {
        self.search.approveStartTime = self.approveTimeRange[0] + ' ' + '00:00:00';
        self.search.approveEndTime = self.approveTimeRange[1] + ' ' + '23:59:59';
      }
      // if(self.search.isES=="Y"){
      //   self.search.dataSource=['4']
      // }else if(self.search.isES=="N"){
      //   self.search.dataSource=['1','2','3']
      // }else{
      //   self.search.dataSource=[]
      // }
      
      let url=this.postUrl
      let query=Object.assign(self.page, self.search)
      
      console.log('query',query);
      
      self.tableLoading = true;
      this.$refs.table.$refs.multipleTable?.clearSelection()
      self.api.postJson(url, query).then(res => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records || [];
          self.$refs.table.$refs.multipleTable.doLayout();
          self.$refs.table.$refs.multipleTable.clearSelection();
          self.$refs.table.$refs.multipleTable.bodyWrapper.scrollTop = 0
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    empty() {
      let self = this;
      this.createTimeRange = [],
      this.updateTimeRange = [],
      this.approveTimeRange = [],
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        dataType:this.page.dataType,//资料类型
        loadApproveState:'Y',
      },
      this.search = {
        tenantGuid: this.search.tenantGuid,//公司名称
        customerName:'',//客户名称
        medNameKeyword: '',//医院
        franchiseeName: '',//商业公司
        province:'',//所属省
        belongStaffName: '',//人员信息
        submitStaffName: '',//更新人
        bizStateList:['Y'],//启用状态'Y','S'
        plfApproveState:'A',//审核状态
        srcEsDb:'',//是否底库建档
      },
      this.activeTab = 1
      self.getData(true)
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      if (val && val.length > 0) {
        val.forEach(function (item) {
          self.multipleSelection.push(item);
        });
      }
      this.$forceUpdate()
    },
    // 搜索列表区域---end----------
   

    

    // 操作按钮区域---start----------
    // 查看详情
    toDetail(row){
      let type=this.page.dataType
      let lookUp={
        '1':"/pharmacyDetail/detail",
        '2':"/medQueryDetail/detail",
        '3':"/commercialCompanyinquiryDetail/detail"
      }
      if(type=='1'){
        sessionStorage.removeItem("fillRefresh");
        if (!localStorage.getItem("TZYDJD_CONFIG")) {
          this.$message.error("功能界面内容未配置，请联系运营人员处理");
          return;
        }
      }
      let query={
        guid: row.guid,
        tenantGuid: this.search.tenantGuid,
        productGuid: this.$route.query.productGuid,
        disabled:true,
        isAudit:true,
        approveState:row.approveVO.approveState,
        approveGuid:row.approveVO.guid,
      }
      this.$router.push({
        path: lookUp[type],
        query: query
      })
    },
    // 查看历史审核记录
    async historyReviewRecords(item, type) {
      this.tableLoading = true;
      let res = [];
      res = await this.approveHistory(item);
      if (res && res.length) {
        this.$root.$emit('viewReviewRecords', {
          openReviewRecords: true,
          title:'历史审批原因',
          type,
          reviewList: res,
        });
      }
      this.tableLoading = false;
    },
    //获取历史记录
    approveHistory(item) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.api
          .get(
            `/${serverConfig.msCustomerService}/plf-base-approve/approve-history?approveGuid=${item.approveVO.guid}`,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              resolve(res.data.data);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    //单个审核
    toAudit(item) {
      this.approveGuidList = [item.approveVO.guid];
      this.approvalState=''
      this.issuesDesc=''//原因说明
      this.checkedIssues=[]
      this.isBatch=false
      this.dialogVisible=true
    },
    //批量审核
    batchAudit() {
      this.approvalState=''
      this.issuesDesc=''//原因说明
      this.checkedIssues=[]
      if(this.multipleSelection.length<1){
        this.$message.error('请勾选数据');
        return;
      }
      this.isBatch=true
      this.dialogVisible=true
    },
    //提交审核
    toAuditSubmit() {
      if (!this.approvalState) {
        this.$message.error('审核结果不能为空');
        return;
      }
      if (
        this.approvalState == 'N' &&
        !this.issuesDesc
      ) {
        this.$message.error('请填写原因说明');
        return;
      }
      this.toAuditRequire();
    },
    //发起审核请求
    toAuditRequire() {
      this.fullscreenLoading = true;
      let userInfo = JSON.parse(localStorage.userInfo);
      let list=[]
      if (this.isBatch) {
        // this.taskDataList.forEach((item) => {
        this.multipleSelection.forEach((item) => {
          // list.push(item.guid);
          if(item.approveVO&&item.approveVO.guid){
            list.push(item.approveVO.guid);
          }
          
        });
      }
      let query = {
        customerPlfApproveGuidList: this.isBatch?list:this.approveGuidList,
        approveStaffGuid: userInfo.staffGuid,
        approveStaffName: userInfo.staffName,
        approveState: this.approvalState,
        approveSuggest: this.issuesDesc, // 原因说明,
      };
      this.api
        .postJson(`/${serverConfig.msCustomerService}/plf-base-approve/submit-approve`, query)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('审核成功');
            this.dialogVisible = false;
            this.getData(true);
          } else {
            this.$message.error(`${this.messageErrorTip}${res.msg ? `:${res.msg}` : ''}`);
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 操作按钮区域---end----------



    // 审核区域---start----------
    // 审核原因勾选事件
    checkedIssuesChange(newVal, oldVal) {
      if (newVal.length && newVal.length > oldVal.length) {
        let arr = [];
        if (newVal && Array.isArray(newVal)) {
          let len = newVal.length;
          let item = newVal[len - 1];
          arr.push(`${len}、${item}`);
        }
        this.issuesDesc = this.issuesDesc + arr.join('\n') + '\n';
        this.issuesDesc = this.issuesDesc.slice(0, 200)
      }
    },
    // 原因说明输入校验
    checkedIssuesTextEvent(val) {
      if (!/^[a-zA-Z0-9_-、%()（），.。,\-\u4e00-\u9fa5\n]+$/.test(val) && val) {
        this.$NewMessage.warning({
          message: '仅可输入汉字、英文、数字、下划线【_】、减号【-】',
        });
      }
    },
    //切换审核状态
    changeTab(index, item) {
      this.search.plfApproveState = item.value;
      this.activeTab = index;
      this.getData(true);
    },
    // 审核区域---end----------

    
  },
};
</script> 
<style lang="less">

  .dialog-title {
    text-align: left;
    width: 240px;
    height: 27px;
    font-family: PingFang SC;
    font-size: 18px;
    color: #212121;
    letter-spacing: 0;
    line-height: 27px;
    font-weight: 400;
  }
  .search-area-div{
    width: 84px;
  }
</style>

